import React, { useState, useEffect } from 'react';
import axios from 'axios';
import localforage from 'localforage';
import { FiShoppingCart, FiX, FiSearch } from 'react-icons/fi';
import API_BASE_URL from "./apiConfig";
import pro_bg from "../assets/productbanner.jpg";
import Header from './HeaderLayouts';
import Footer from './FooterLayouts';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { jsPDF } from "jspdf";
import firecracker from "../assets/firecracker_img.webp";
import logo from "../assets/HaribalajiLogo.png";
const ProductCatalog = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cartItems, setCartItems] = useState({});
  const location = useLocation();
  const [cartProducts, setCartProducts] = useState([]);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const formRef = React.useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [orderDetails, setOrderDetails] = useState(null);
  const [orderId, setOrderId] = useState("");
  const [finalAmountToPay, setFinalAmountToPay] = useState(0);
  const [amountBelowMinimum, setAmountBelowMinimum] = useState(false);
  const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
  const [productToRemove, setProductToRemove] = useState(null);
  const [previousQuantity, setPreviousQuantity] = useState(1);
  const [showOrderCard, setShowOrderCard] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false); // Added for processing state
  const [previewImage, setPreviewImage] = useState(null);
  const [minOrderAmount, setMinOrderAmount] = useState(3000);
  const [searchTerm, setSearchTerm] = useState('');
  // Load cart from localStorage on initial render
  // useEffect(() => {
  //   const savedCart = localStorage.getItem('cart');
  //   if (savedCart) {
  //     setCartItems(JSON.parse(savedCart));
  //   }
  // }, []);

  // Save cart to localStorage whenever it changes
  // useEffect(() => {
  //   localStorage.setItem('cart', JSON.stringify(cartItems));
  // }, [cartItems]);

  // First, update your initial quantities state to store product info:
  const [quantities, setQuantities] = useState({});

  // Then modify handleQuantityChange:
  const handleQuantityChange = (productId, value) => {
    // Allow empty string (when user clears the input)
    if (value === '') {
      setQuantities(prev => {
        const newQuantities = { ...prev };
        delete newQuantities[productId];
        return newQuantities;
      });
      setCartItems(prev => {
        const newCart = { ...prev };
        delete newCart[productId];
        return newCart;
      });
      return;
    }
    const numValue = parseInt(value);
    if (isNaN(numValue)) return;
    const newQuantity = Math.max(1, numValue);
    // Find the product in categories
    let productDetails = null;
    Object.keys(categories).some(categoryName => {
      const product = categories[categoryName].find(p => p.id === productId);
      if (product) {
        productDetails = product;
        return true;
      }
      return false;
    });
    if (!productDetails) return;

    setQuantities(prev => ({
      ...prev,
      [productId]: newQuantity
    }));

    // Add to cart automatically when quantity is set
    setCartItems(prev => ({
      ...prev,
      [productId]: {
        id: productId,
        quantity: newQuantity,
        name: productDetails.prodName,
        price: productDetails.discountPrice,
        originalPrice: productDetails.prodPrice,
        image: productDetails.prodImage
      }
    }));
  };

  // Fetch products and group by category
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        setError(null); // Reset error state
        // Add CompanyId=2 as a default parameter
        const response = await axios.get(`${API_BASE_URL}api/Crackers/GetProductSummary?CompanyId=3`);
        if (response.data.statusCode === 200 && Array.isArray(response.data.result)) {
          const products = response.data.result;
          // Group products by categoryName
          const grouped = products.reduce((acc, product) => {
            const { categoryName } = product;
            if (!acc[categoryName]) {
              acc[categoryName] = [];
            }
            acc[categoryName].push(product);
            return acc;
          }, {});
          setCategories(grouped);
        } else {
          setError('Failed to load products or no data available.');
        }
      } catch (err) {
        console.error('Error fetching products:', err);
        if (err.response) {
          setError(`Failed to load products: ${err.response.statusText}`);
        } else if (err.request) {
          setError('No response from server. Please check your network connection.');
        } else {
          setError('An error occurred while fetching products.');
        }
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // Fetch minimum order amount
  useEffect(() => {
    const fetchMinOrderAmount = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}api/Crackers/GetMinimumOrderAmount?companyId=3`);
        if (response.data.statusCode === 200) {
          setMinOrderAmount(response.data.data.minOrderAmount);
        }
      } catch (error) {
        console.error('Error fetching minimum order amount:', error);
      }
    };
    fetchMinOrderAmount();
  }, []);

  // Reset view states when navigating back to the page
  useEffect(() => {
    // Reset form and cart view when component mounts or location changes
    setShowDetailsForm(false);
    setShowOrderCard(false);
  }, [location.pathname]);

  // Format price without currency symbol
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 0,
    }).format(price);
  };

  // Calculate discount percentage
  const getDiscountPercent = (marketPrice, discountPrice) => {
    if (!marketPrice || !discountPrice || marketPrice <= 0) return 0;
    const discount = ((marketPrice - discountPrice) / marketPrice) * 100;
    return Math.round(discount);
  };

  const handleViewCart = () => {
    // Convert cartItems object to array for display
    const products = Object.values(cartItems).map(item => ({
      id: item.id,
      name: item.name,
      quantity: item.quantity,
      price: item.price,
      originalPrice: item.originalPrice,
      subtotal: item.price * item.quantity,
      image: item.image,
      discountPercent: item.originalPrice && item.price
        ? Math.round(((item.originalPrice - item.price) / item.originalPrice) * 100)
        : 0,
    }));
    setCartProducts(products);
    setShowOrderCard(true);

    setTimeout(() => {
      const orderCardElement = document.getElementById('orderCard');
      if (orderCardElement) {
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;
        const offset = orderCardElement.offsetTop - headerHeight - 60;
        window.scrollTo({
          top: offset,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  // Count of unique products in cart
  const productCount = Object.keys(cartItems).length;

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const initialProducts = [];

  const handleProceedClick = () => {
    if (subTotal < minOrderAmount) {
      return; // Don't proceed if amount is below minimum
    }
    setShowDetailsForm(true);
    // Create a small delay to ensure the DOM has updated
    setTimeout(() => {
      const formElement = document.getElementById('orderDetailsForm');
      if (formElement) {
        // Calculate the position to scroll to (accounting for any fixed headers)
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;
        const elementPosition = formElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight - 40;
        // Smooth scroll to the form section
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const handleConfirmOrder = async () => {
    // Validation
    if (!formData.firstName || !formData.contactNumber || !formData.address ||
      !formData.pinCode || !formData.city || !formData.district || !formData.state) {
      alert("Please fill all required fields.");
      return;
    }

    // First check if terms checkbox is checked
    const termsCheckbox = document.getElementById('agreeToTerms');
    if (!termsCheckbox.checked) {
      alert("Please Check the I have read and agree to the Terms and Conditions before confirming your order");
      return; // Stop execution if not checked
    }

    const contactNumber = formData.contactNumber.trim();
    const whatsappNumber = formData.whatsappNumber.trim();
    if (!contactNumber || !/^\d{10}$/.test(contactNumber)) {
      alert("Contact Number must be exactly 10 digits.");
      return;
    }
    if (!whatsappNumber || !/^\d{10}$/.test(whatsappNumber)) {
      alert("WhatsApp Number must be exactly 10 digits.");
      return;
    }

    // Prepare products array for API
    const productsPayload = cartProducts.map(item => ({
      id: item.id,
      qty: item.quantity
    }));

    // Create payload with CompanyId=2
    const payload = {
      CompanyId: 3,
      FirstName: formData.firstName,
      LastName: formData.lastName || "",
      PhoneNumber: formData.contactNumber,
      AltPhoneNumber: formData.whatsappNumber || formData.contactNumber,
      Street: formData.address,
      City: formData.city,
      District: formData.district || formData.city,
      State: formData.state,
      PINCode: formData.pinCode,
      EmailID: formData.email || "",
      Products: productsPayload
    };

    try {
      setIsProcessing(true); // Show processing state

      const response = await axios.post(
        `${API_BASE_URL}api/Crackers/ConfirmOrder`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data && response.data.statusCode === 200) {
        const orderId = response.data.data?.orderId || response.data.orderId || "";
        console.log("Order ID:", orderId);

        // Generate PDF first
        await generateOrderPDF(orderId);

        // Clear all data after successful order
        setFormData({
          firstName: '',
          lastName: '',
          contactNumber: '',
          whatsappNumber: '',
          sameAsContact: false,
          address: '',
          city: '',
          district: '',
          state: '',
          pinCode: '',
          email: '',
          totalPayAmount: 0,
          orderId: '',
        });
        setCartProducts([]);
        setCartItems({});
        setQuantities({});
        localStorage.removeItem('cart');
        setShowDetailsForm(false);
        setShowOrderCard(false);

        alert(`✅ Success!\n${response.data.message}`);
      } else {
        alert("Order submitted, but response was unclear. Please contact support.");
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message ||
        error.response?.data?.statusDesc ||
        "Failed to submit order. Please check your internet connection.";
      alert(`❌ Order failed: ${errorMsg}`);
    } finally {
      setIsProcessing(false); // Hide processing state
    }
  };

  // Handle quantity update
  const updateQuantity = (productId, newQuantity) => {
    // If empty string, treat as 0
    if (newQuantity === "" || isNaN(newQuantity)) {
      newQuantity = "";
      // Update cartProducts
      setCartProducts(prevProducts =>
        prevProducts.map(product =>
          product.id === productId
            ? { ...product, quantity: "", subtotal: 0 }
            : product
        )
      );
      // Also update cartItems and quantities
      setCartItems(prev => {
        const updated = { ...prev };
        if (updated[productId]) {
          updated[productId].quantity = "";
        }
        return updated;
      });
      setQuantities(prev => {
        const updated = { ...prev };
        delete updated[productId]; // or set to ""
        return updated;
      });
      return;
    }

    const quantityNum = parseInt(newQuantity, 10);
    if (isNaN(quantityNum) || quantityNum < 1) return;

    // Update cartProducts (display list)
    setCartProducts(prevProducts =>
      prevProducts.map(product =>
        product.id === productId
          ? {
            ...product,
            quantity: quantityNum,
            subtotal: product.price * quantityNum
          }
          : product
      )
    );

    // Also update cartItems (source of truth)
    setCartItems(prev => {
      const updated = { ...prev };
      if (updated[productId]) {
        updated[productId] = {
          ...updated[productId],
          quantity: quantityNum
        };
      }
      return updated;
    });

    // Also update quantities (input state)
    setQuantities(prev => ({
      ...prev,
      [productId]: quantityNum
    }));
  };

  // State for form inputs
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    contactNumber: '',           // Maps to PhoneNumber
    whatsappNumber: '',          // Maps to AltPhoneNumber
    sameAsContact: false,
    address: '',                 // Maps to Street
    city: '',
    district: '',                // If not present, use city or add field
    state: '',
    pinCode: '',
    email: '',
    totalPayAmount: 0,           // From cart total
    orderId: '',                 // Set earlier
  });

  // State for collapsible sections
  const [openSections, setOpenSections] = useState({
    personal: true,
    address: false,
    bank: false,
  });

  // Toggle section function
  const toggleSection = (section) => {
    setOpenSections({
      personal: section === 'personal',
      address: section === 'address',
      bank: section === 'bank',
    });
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => {
      let updatedData = { ...prevData };
      if (type === 'checkbox') {
        updatedData[name] = checked;
        if (name === 'sameAsContact' && checked) {
          updatedData.whatsappNumber = prevData.contactNumber;
        }
      } else {
        if (name === 'contactNumber' || name === 'whatsappNumber' || name === 'pinCode') {
          const numericValue = value.replace(/[^0-9]/g, '').slice(0, 10);
          updatedData[name] = numericValue;
          if (name === 'contactNumber' && prevData.sameAsContact) {
            updatedData.whatsappNumber = numericValue;
          }
        } else if (name === 'accountNumber') {
          const numericValue = value.replace(/[^0-9]/g, '').slice(0, 18);
          updatedData[name] = numericValue;
        } else if (name === 'ifscCode') {
          const alphanumericValue = value.replace(/[^A-Za-z0-9]/g, '').slice(0, 11).toUpperCase();
          updatedData[name] = alphanumericValue;
        } else {
          updatedData[name] = value;
        }
      }
      return updatedData;
    });
  };

  // Calculate totals
  const calculateTotals = () => {
    let netTotal = 0, discountTotal = 0, subTotal = 0;
    cartProducts.forEach(p => {
      netTotal += p.originalPrice * p.quantity;
      discountTotal += (p.originalPrice * p.quantity) - p.subtotal;
      subTotal += p.subtotal;
    });
    return { netTotal, discountTotal, subTotal };
  };

  const { netTotal, discountTotal, subTotal } = calculateTotals();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.firstName || !formData.contactNumber || !formData.address || !formData.pinCode || !formData.city || !formData.district || !formData.state) {
      alert("Please fill all required fields.");
      return;
    }

    const productsPayload = cartProducts.map(item => ({
      id: item.id,
      qty: item.quantity
    }));

    const payload = {
      FirstName: formData.firstName,
      LastName: formData.lastName || "",
      PhoneNumber: formData.contactNumber,
      AltPhoneNumber: formData.whatsappNumber || formData.contactNumber,
      Street: formData.address,
      City: formData.city,
      District: formData.district || formData.city,
      State: formData.state,
      PINCode: formData.pinCode,
      EmailID: formData.email || "",
      Products: productsPayload
    };

    try {
      setIsProcessing(true); // Set processing state

      const response = await axios.post(
        `${API_BASE_URL}api/Crackers/ConfirmOrder`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      console.log("📦 ConfirmOrder API Response:", response.data);

      if (response.data && response.data.statusCode === 200) {
        // ✅ Extract OrderId correctly from the actual response
        const orderId = response.data.orderId;
        if (!orderId) {
          console.error("❌ Order ID not found in response:", response.data);
          alert("Order confirmed, but no Order ID returned. Please contact support.");
          return;
        }

        console.log("✅ Final Order ID to send:", orderId);

        // ✅ Generate PDF and get blob
        const pdfBlob = generateOrderPDF(orderId); // This saves the PDF and returns blob
        console.log("📄 Generated PDF Blob:", pdfBlob);

        // ✅ Prepare FormData for file upload
        const formDataToSend = new FormData();
        formDataToSend.append("Document", pdfBlob, `Order_${orderId}.pdf`);
        formDataToSend.append("CompanyId", 3);
        formDataToSend.append("OrderId", orderId);

        // ✅ Log what we're sending
        console.log("📤 Sending to SendorderedDoc API:");
        console.log("OrderId:", orderId);
        console.log("Document (File):", pdfBlob);

        // ✅ Call SendorderedDoc API
        try {
          const docResponse = await axios.post(
            `${API_BASE_URL}api/Crackers/SendorderedDoc`,
            formDataToSend,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          );

          if (docResponse.data.statusCode === 200) {
            console.log("✅ PDF and Order ID sent successfully");


            const documentUrl = docResponse.data.data?.documentUrl;
            if (!documentUrl) {
              console.warn("⚠️ No documentUrl found in SendorderedDoc response:", docResponse.data);
              alert("Order confirmed, but document URL not available. Please contact support.");
            } else {
              console.log("✅ Retrieved documentUrl:", documentUrl);

              // ✅ Call SendMessage API
              try {
                const whatsappPayload = {
                  to: formData.whatsappNumber || formData.contactNumber,
                  pdfUrl: documentUrl,
                  text: `HARIBALAJI TRADERS Order #${orderId}`, // Fixed company name
                  orderNumber: orderId,
                  companyName: "HARIBALAJI TRADERS" // Added company name to payload
                };

                const whatsappResponse = await axios.post(
                  // `${API_BASE_URL}api/Whatsapp/SendMessage/sendmessage`,
                  whatsappPayload,
                  {
                    headers: {
                      'Content-Type': 'application/json',
                    },
                  }
                );

                if (whatsappResponse.data.statusCode === 200) {
                  console.log("✅ WhatsApp message sent successfully");
                } else {
                  console.warn("⚠️ SendMessage API non-200:", whatsappResponse.data);
                  alert("Order confirmed, but WhatsApp message not sent. Please contact support.");
                }
              } catch (whatsappError) {
                console.error("❌ Error sending WhatsApp message:", whatsappError);
                alert("Order confirmed, but failed to send WhatsApp message. Please contact support.");
              }
            }
          } else {
            console.warn("⚠️ SendorderedDoc API non-200:", docResponse.data);
            alert("Order confirmed, but document not sent. Please contact support.");
          }
        } catch (docError) {
          console.error("❌ Error sending document:", docError);
          alert("Order confirmed, but failed to send document. Please contact support.");
        }

        // ✅ Reset form and cart
        setFormData({
          firstName: '',
          lastName: '',
          contactNumber: '',
          whatsappNumber: '',
          sameAsContact: false,
          address: '',
          city: '',
          district: '',
          state: '',
          pinCode: '',
          email: '',
          totalPayAmount: 0,
          orderId: '',
        });
        setCartProducts([]);
        setCartItems({});
        localStorage.removeItem('cart');
        setShowDetailsForm(false);
        alert(`✅ Success!\n${response.data.message}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        alert("Order submitted, but response was unclear. Please contact support.");
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message ||
        error.response?.data?.statusDesc ||
        "Failed to submit order or send document.";
      console.error("❌ Error in handleSubmit:", errorMsg, error);
      alert(`❌ Order failed: ${errorMsg}`);
    } finally {
      setIsProcessing(false); // Reset processing state
    }
  };

  useEffect(() => {
    setAmountBelowMinimum(subTotal < minOrderAmount);
  }, [subTotal, minOrderAmount]);

  const styles = {
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '1rem',
      // paddingBottom: '40px',
    },
    header: {
      fontSize: '2rem',
      color: '#1a237e',
      textAlign: 'center',
      margin: '1rem 0 2rem',
    },
    loading: {
      textAlign: 'center',
      color: '#666',
    },
    error: {
      textAlign: 'center',
      color: '#d32f2f',
    },
    noData: {
      textAlign: 'center',
      color: '#666',
    },
    categorySection: {
      marginBottom: '2.5rem',
    },
    categoryTitle: {
      fontSize: '1.5rem',
      color: '#6B3F69', // Changed to your requested color
      borderBottom: '2px solid #FFD700', // Yellow color as requested
      paddingBottom: '0.5rem',
      marginBottom: '1.5rem',
      fontWeight: 'bold',
    },
    productGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', // Reduced from 280px to 200px
      gap: '1rem', // Reduced from 1.5rem
    },


    productCard: {
      borderRadius: '8px', // Reduced from 12px
      padding: '0.6rem', // Reduced from 0.8rem
      display: 'flex',
      flexDirection: 'column',
      transition: 'all 0.3s ease',
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: '#f1e9f1ff',
      border: '1px solid #ddaadbff',
      boxShadow: '0px 4px 12px rgba(107, 63, 105, 0.4)', // Reduced shadow
      minHeight: '140px', // Reduced from 160px
      height: 'auto',
    },

    productImageContainer: {
      position: 'relative',
      width: '100%',
      height: '140px', // Increased from 120px for bigger image
      overflow: 'hidden',
      borderRadius: '6px',
      cursor: 'pointer',
      marginBottom: '0.4rem',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    productImage: {
      objectFit: 'contain',
      cursor: 'zoom-in',
      display: 'block',
      width: '80%', // Increased from 50% for bigger image
      height: '130px', // Increased from 100px
      backgroundColor: '#f5f5f5',
      borderRadius: '6px',
      maxWidth: '100%',
      maxHeight: '100%',
    },
    productName: {
      fontSize: '12px', // Reduced from 14px
      fontWeight: '600',
      margin: '0.2rem 0', // Reduced margin
      color: '#333',
      textAlign: 'center',
      lineHeight: '1.2',
    },
    discountBadge: {
      position: 'absolute',
      top: '10px',
      left: '10px',
      backgroundColor: '#FF4444',
      color: 'white',
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '0.8rem',
      fontWeight: 'bold',
      zIndex: 2,
    },
    priceContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '0.2rem 0', // Reduced from 0.3rem
      padding: '0 0.3rem', // Reduced from 0.5rem
    },

    marketPriceSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },

    discountPriceSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },

    priceLabel: {
      fontSize: '0.7rem',
      color: '#666',
      marginBottom: '0.05rem',
    },

    marketPrice: {
      fontSize: '0.75rem',
      color: '#666',
      textDecoration: 'line-through',
    },

    discountPrice: {
      fontSize: '0.85rem', // Reduced from 0.9rem
      color: '#FF9800',
      fontWeight: 'bold',
    },
    unitInfo: {
      fontSize: '0.75rem', // Reduced from 0.85rem
      color: '#666',
      textAlign: 'center',
      margin: '0.3rem 0', // Reduced from 0.5rem
    },
    actionContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 'auto',
      paddingTop: '0.5rem',
      width: '100%',
    },
    quantityInput: {
      width: '100px', // Reduced from 80px
      padding: '0.4rem', // Reduced from 0.5rem
      border: '1px solid #ddd',
      borderRadius: '4px',
      textAlign: 'center',
      fontSize: '0.9rem', // Reduced from 1rem
    },
    placeholderImage: {
      width: '100%',
      height: '150px',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#999',
      borderRadius: '4px',
      marginBottom: '0.5rem',
      display: 'none',
    },

    priceRow: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '0.2rem',
    },
    priceLabel: {
      fontSize: '0.85rem',
      color: '#666',
      marginRight: '0.3rem',
    },
    marketPrice: {
      fontSize: '0.85rem',
      color: '#666',
      textDecoration: 'line-through',
    },
    discountPrice: {
      fontSize: '1rem',
      color: '#FF9800',
      fontWeight: 'bold',
      marginRight: '0.3rem',
    },
    discountPercentage: {
      fontSize: '0.9rem',
      fontWeight: 'bold',
      color: '#4CAF50',
      marginLeft: '160px'
    },
    discount: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
    },

    unitInfo: {
      fontSize: '0.8rem',
      color: '#666',
      margin: '0.1rem 0',
    },

    cartSummaryContainer: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#532a51ff',
      padding: '0.8rem 1rem',
      boxShadow: '0 -2px 10px rgba(0,0,0,0.2)',
      zIndex: 1000,
    },
    cartSummaryContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    cartIconContainer: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    },
    cartIcon: {
      fontSize: '1.5rem',
      color: 'white',
    },
    cartBadge: {
      position: 'absolute',
      top: '-8px',
      right: '-8px',
      backgroundColor: '#FF9800',
      color: 'white',
      borderRadius: '50%',
      width: '20px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.7rem',
      fontWeight: 'bold',
    },
    viewCartButton: {
      padding: '0.6rem 1.2rem',
      backgroundColor: '#f5ae42ff',
      color: 'white',
      textDecoration: 'none',
      borderRadius: '4px',
      fontWeight: 'bold',
      transition: 'all 0.2s',
      ':hover': {
        backgroundColor: '#F57C00',
      },
    },
    container: {
      fontFamily: "'Poppins', sans-serif",
      backgroundColor: '#f8fafc',
      color: '#1e293b',
      lineHeight: 1.4,
      padding: isMobile ? '0.5rem' : '1rem',
      minHeight: 'calc(100vh - 100px)',
      paddingTop: '50px',
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      margin: '0px auto',
      maxWidth: isMobile ? '100%' : '1200px',
      width: '100%',
    },
    orderCard: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: '1rem',
      width: '100%',
      minHeight: '400px',
      marginBottom: '2rem',
      scrollMarginTop: '60px',
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '0.5rem',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      flex: 1,
    },
    cardHeader: {
      textAlign: 'center',
      padding: '0.6rem 0',
      backgroundColor: '#532a51ff',
      color: '#ffffffff',
    },
    cardTitle: {
      margin: 0,
      fontSize: isMobile ? '0.9rem' : '1rem',
      fontWeight: 600,
    },
    cardBody: {
      padding: isMobile ? '0.5rem' : '0.75rem',
      display: 'flex',
      flexDirection: 'column',
    },
    productList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      overflowY: 'auto',
      maxHeight: isMobile ? '300px' : '400px',
      minHeight: '200px', // Ensure minimum height
    },
    productItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #e2e8f0',
      padding: isMobile ? '0.4rem 0.25rem' : '0.4rem 0.5rem',
      flexWrap: isMobile ? 'wrap' : 'nowrap',
      gap: isMobile ? '0.25rem' : '0',
    },
    productInfo: {
      display: 'flex',
      alignItems: 'center',
      flex: isMobile ? '1 0 100%' : 1,
      marginBottom: isMobile ? '0.25rem' : 0,
      gap: isMobile ? '0.5rem' : '0.75rem', // 👈 Add this line
    },

    productDetails: {
      flex: 1,
    },

    productMeta: {
      margin: '0.2rem 0 0',
      fontSize: isMobile ? '0.7rem' : '0.75rem',
      color: '#64748b',
    },
    productPrice: {
      fontWeight: 600,
      fontSize: isMobile ? '0.75rem' : '0.8rem',
      color: '#1e293b',
      minWidth: isMobile ? '70px' : '75px', // Increased minWidth for mobile
      textAlign: 'right',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.2rem',
      paddingRight: isMobile ? '0.25rem' : '0.5rem',
      flexShrink: 0, // Prevent shrinking
    },
    quantityInputStyle: {
      width: isMobile ? '35px' : '45px',
      padding: '0.3rem',
      border: '1px solid #ddd',
      borderRadius: '3px',
      textAlign: 'center',
      fontSize: isMobile ? '0.75rem' : '0.8rem'
    },
    totalsSection: {
      marginTop: '0.4rem',
      padding: isMobile ? '0.75rem' : '1rem',
      paddingBottom: '0.5rem',
    },
    totalRow: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '0.5rem',
      fontSize: isMobile ? '0.9rem' : '1rem',
    },
    totalLabel: {
      color: '#64748b',
      fontSize: isMobile ? '0.8rem' : '1rem',
    },
    totalValue: {
      fontWeight: 600,
      fontSize: isMobile ? '0.8rem' : '1rem',
      color: 'black',
    },
    grandTotal: {
      borderTop: '1px solid #cbd5e1',
      marginTop: '1rem',
      paddingTop: '1rem',
      fontWeight: 700,
      fontSize: isMobile ? '0.9rem' : '1.2rem',
      color: '#1e293b',
    },
    proceedButton: {
      backgroundColor: '#532a51ff',
      color: 'white',
      padding: isMobile ? '0.5rem 0.5rem' : '0.5rem 1.1rem',
      border: 'none',
      borderRadius: '0.375rem',
      cursor: 'pointer',
      fontWeight: 600,
      fontSize: isMobile ? '0.95rem' : '0.9rem',
      transition: 'background-color 0.3s ease, transform 0.2s ease',
      alignSelf: 'center',
      width: isMobile ? '100%' : 'fit-content',
    },
    formContainer: {
      width: '100%',
    },
    formBody: {
      padding: isMobile ? '0.5rem' : '0.75rem',
    },
    formRow: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '0.5rem' : '0.75rem',
      width: '100%',
      marginBottom: '0.5rem',
    },
    formGroup: {
      flex: 1,
      minWidth: 0,
    },
    fullWidth: {
      width: '100%',
    },
    formLabel: {
      display: 'block',
      width: '100%',
      marginBottom: '0.25rem',
      color: '#1e293b',
      fontSize: isMobile ? '0.8rem' : '0.85rem',
      fontWeight: 600,
    },
    formInput: {
      width: '100%',
      padding: isMobile ? '0.6rem' : '0.5rem',
      border: '1px solid #cbd5e1',
      borderRadius: '0.375rem',
      marginBottom: '0.25rem',
      fontSize: isMobile ? '0.9rem' : '0.85rem',
      transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
      boxSizing: 'border-box',
    },
    formAddress: {
      width: '100%',
      padding: isMobile ? '0.6rem' : '0.5rem',
      border: '1px solid #cbd5e1',
      borderRadius: '0.375rem',
      resize: 'vertical',
      minHeight: '2.5rem',
      fontSize: isMobile ? '0.9rem' : '0.85rem',
      transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
      boxSizing: 'border-box',
      marginBottom: '0.25rem',
    },
    checkboxContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '0.25rem',
    },
    formCheckbox: {
      marginRight: '0.5rem',
      width: isMobile ? '18px' : '16px',
      height: isMobile ? '18px' : '16px',
    },
    sectionTitle: {
      fontSize: isMobile ? '0.9rem' : '0.95rem',
      fontWeight: 600,
      color: '#2F3E9E',
      marginBottom: '0.5rem',
      paddingBottom: '0.4rem',
      borderBottom: '1px solid #e2e8f0',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      transition: 'all 0.3s ease',
      padding: '0.4rem',
      borderRadius: '0.25rem',
    },
    sectionContent: {
      overflow: 'hidden',
      padding: '0.5rem',
    },
    sectionContentOpen: {
      maxHeight: '1000px',
      opacity: 1,
      marginBottom: '0.5rem',
    },
    sectionContentClosed: {
      maxHeight: '0px',
      opacity: 0,
      marginBottom: '0rem',
    },
    formDetailsColumns: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: '1rem',
    },
    formColumn: {
      flex: 1,
      border: '1px solid #e2e8f0',
      borderRadius: '0.375rem',
      padding: isMobile ? '0.5rem' : '0.75rem',
    },
    submitSection: {
      padding: isMobile ? '0.75rem' : '0.5rem',
    },
    termsSection: {
      backgroundColor: '#f8fafc',
      borderRadius: '0.5rem',
      paddingTop: '0.1rem',
      marginBottom: '1rem',
    },
    termsCheckbox: {
      marginRight: '0.5rem',
    },
    requiredField: {
      color: '#dc2626',
      marginLeft: '0.125rem',
    },
    actionButtons: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: '0.75rem',
      gap: '0.75rem',
    },
    confirmButton: {
      backgroundColor: 'green',
      color: 'white',
      padding: isMobile ? '0.75rem 1.5rem' : '0.6rem 1.2rem',
      border: 'none',
      borderRadius: '0.375rem',
      cursor: 'pointer',
      fontWeight: 600,
      fontSize: isMobile ? '0.95rem' : '0.9rem',
      transition: 'background-color 0.3s ease, transform 0.2s ease',
      flex: 1,
      minWidth: isMobile ? '100%' : '120px',
      width: isMobile ? '100%' : 'auto',
    },
    cancelButton: {
      backgroundColor: '#94a3b8',
      color: 'white',
      padding: isMobile ? '0.75rem 1.5rem' : '0.6rem 1.2rem',
      border: 'none',
      borderRadius: '0.375rem',
      cursor: 'pointer',
      fontWeight: 600,
      fontSize: isMobile ? '0.95rem' : '0.9rem',
      transition: 'background-color 0.3s ease, transform 0.2s ease',
      flex: 1,
      minWidth: isMobile ? '100%' : '100px',
      width: isMobile ? '100%' : 'auto',
    },
    // Mobile-specific price layout
    mobileDiscountBadge: {
      color: '#10B981',
      fontSize: '0.7rem',
      fontWeight: 'bold',
      padding: '0.2rem 0.4rem',
      borderRadius: '0.25rem',
      backgroundColor: '#ecfdf5',
      border: '1px solid #10B981',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      marginTop: '0.25rem',
    },
    mobileQuantitySection: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      marginTop: '0.25rem',
      paddingTop: '0.25rem',
      borderTop: '1px solid #f1f5f9',
    },
    mobilePriceSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '0.2rem',
    },
    popupOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: isMobile ? '1rem' : '2rem',
    },
    popupContainer: {
      backgroundColor: 'white',
      borderRadius: '0.5rem',
      maxWidth: isMobile ? '95%' : '600px',
      maxHeight: isMobile ? '90vh' : '80vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      overflow: 'hidden',
    },
    popupHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: isMobile ? '0.75rem 1rem' : '1rem 1.5rem',
      borderBottom: '1px solid #e2e8f0',
      backgroundColor: '#f8fafc',
    },
    popupTitle: {
      margin: 0,
      fontSize: isMobile ? '1.1rem' : '1.25rem',
      color: '#1e293b',
    },
    popupCloseButton: {
      background: 'none',
      border: 'none',
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: '#dc2626',
      cursor: 'pointer',
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      transition: 'background-color 0.2s',
    },
    popupContent: {
      padding: isMobile ? '1rem' : '1.5rem',
      fontSize: isMobile ? '0.85rem' : '0.9rem',
      lineHeight: 1.5,
      color: '#334155',
      maxHeight: '60vh',
      overflowY: 'auto',
    },
    popupFooter: {
      padding: isMobile ? '0.75rem 1rem' : '1rem 1.5rem',
      borderTop: '1px solid #e2e8f0',
      backgroundColor: '#f8fafc',
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
    },
    // Processing overlay style
    //   processingOverlay: {
    //     position: 'fixed',
    //     top: 0,
    //     left: 0,
    //     right: 0,
    //     bottom: 0,
    //     backgroundColor: 'rgba(0,0,0,0.5)',
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     zIndex: 2000,
    //   },
    //   processingContent: {
    //     backgroundColor: 'white',
    //     padding: '2rem',
    //     borderRadius: '0.5rem',
    //     display: 'flex',
    //     flexDirection: 'column',
    //     alignItems: 'center',
    //     boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    //   },
    //   processingText: {
    //     marginTop: '1rem',
    //     fontSize: '1.1rem',
    //     color: '#1e293b',
    //   }
  };

  const generateOrderPDF = async (orderId) => {
    if (!orderId) return;

    const doc = new jsPDF();
    const pageWidth = 210;
    const pageHeight = 297;
    const margin = 15;
    const contentWidth = pageWidth - 2 * margin;
    let currentPage = 1;
    let yPos = 40; // Initial Y after header

    // === Function to add header ===
    const addFirstPageHeader = () => {
      doc.setFillColor(30, 58, 138);
      doc.rect(0, 0, pageWidth, 26, 'F');

      if (logo) {
        const logoCenterX = 28;
        const logoCenterY = 12;
        const logoWidth = 15;
        const logoHeight = 15;

        doc.setFillColor(255, 255, 255);
        doc.ellipse(logoCenterX, logoCenterY, logoWidth / 2, logoHeight / 2, 'F');
        doc.addImage(
          logo,
          "PNG",
          logoCenterX - logoWidth / 2,
          logoCenterY - logoHeight / 2,
          logoWidth,
          logoHeight
        );
      }

      doc.setTextColor(255, 255, 255);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text("HARIBALAJI TRADERS", pageWidth / 2, 16, { align: "center" });

      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text("Premium Quality Fireworks & Sparklers", pageWidth / 2, 22, { align: "center" });

      doc.setFillColor(16, 185, 129);
      doc.rect(150, 8, 50, 12, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("ORDER CONFIRMED", 175, 15, { align: "center" });
    };

    const checkPageBreak = (yPos, requiredHeight) => {
      const availableHeight = pageHeight - margin - yPos;
      if (requiredHeight > availableHeight) {
        doc.addPage();
        currentPage++;
        return 25; // Reset Y on new page
      }
      return yPos;
    };

    // === Initialize First Page ===
    addFirstPageHeader();

    if (currentPage === 1) {
      doc.setTextColor(30, 58, 138);
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text("Thank You for Your Order!", pageWidth / 2, yPos, { align: "center" });
      yPos += 8;

      doc.setTextColor(100, 100, 100);
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.text(
        `Order Date: ${new Date().toLocaleDateString('en-GB')} | Order No-${orderId}`,
        pageWidth / 2,
        yPos,
        { align: "center" }
      );
      yPos += 15;
    }

    // === Customer Details Section ===
    const startX = margin;
    const boxWidth = contentWidth;
    const lineHeight = 6; // Consistent line height for all fields

    const addressText = `${formData.address}, ${formData.city}, ${formData.district || formData.city}, ${formData.state}, ${formData.pinCode}`;
    const addressLines = doc.splitTextToSize(addressText, boxWidth - 60);

    // Calculate height based on actual number of address lines needed
    const customerDetailsHeight =
      10 + 3 + (lineHeight * 3) + (lineHeight * addressLines.length) +
      (formData.email ? lineHeight : 0) + 6;

    yPos = checkPageBreak(yPos, customerDetailsHeight + 5);

    doc.setFillColor(248, 250, 252);
    doc.setDrawColor(226, 232, 240);
    doc.setLineWidth(0.5);
    doc.rect(startX, yPos, boxWidth, customerDetailsHeight, 'FD');

    doc.setFillColor(30, 58, 138);
    doc.rect(startX, yPos, boxWidth, 10, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("CUSTOMER DETAILS", startX + 5, yPos + 6.5);

    yPos += 13;
    doc.setTextColor(60, 60, 60);
    doc.setFontSize(10);

    const labelX = startX + 5;
    const valueStartX = startX + 50;

    // Name
    doc.setFont("helvetica", "bold");
    doc.text("Name:", labelX, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(`${formData.firstName} ${formData.lastName}`, valueStartX, yPos);
    yPos += lineHeight;

    // Contact No
    doc.setFont("helvetica", "bold");
    doc.text("Contact No:", labelX, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(formData.contactNumber, valueStartX, yPos);
    yPos += lineHeight;

    // WhatsApp No
    doc.setFont("helvetica", "bold");
    doc.text("Whatsapp No:", labelX, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(formData.whatsappNumber, valueStartX, yPos);
    yPos += lineHeight;

    // Address - Only add space for actual lines needed
    doc.setFont("helvetica", "bold");
    doc.text("Address:", labelX, yPos);
    doc.setFont("helvetica", "normal");

    // Add each address line at the correct position with consistent spacing
    addressLines.forEach((line) => {
      doc.text(line, valueStartX, yPos);
      yPos += lineHeight; // Consistent line height for all address lines
    });

    // Email - Consistent spacing like other fields
    if (formData.email) {
      doc.setFont("helvetica", "bold");
      doc.text("Email:", labelX, yPos);
      doc.setFont("helvetica", "normal");
      doc.text(formData.email, valueStartX, yPos);
      yPos += lineHeight;
    }

    yPos += 10;

    // === ORDER SUMMARY SECTION ===
    const tableStartY = yPos;
    let tableCurrentY = yPos;
    let isTableContinued = false; // Track if table is continued on new page

    // Check space for header
    tableCurrentY = checkPageBreak(tableCurrentY, 30);
    if (tableCurrentY === 25) {
      isTableContinued = true;
      tableCurrentY = 25;
    }

    // Draw header section
    doc.setFillColor(248, 250, 252);
    doc.setDrawColor(226, 232, 240);
    doc.setLineWidth(0.5);
    doc.rect(margin, tableCurrentY, contentWidth, 10, 'FD');

    doc.setFillColor(30, 58, 138);
    doc.rect(margin, tableCurrentY, contentWidth, 10, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");

    if (isTableContinued) {
      doc.text("ORDER SUMMARY (CONTINUED)", margin + 5, tableCurrentY + 6.5);
    } else {
      doc.text("ORDER SUMMARY", margin + 5, tableCurrentY + 6.5);
    }

    tableCurrentY += 15;

    // === TABLE HEADERS ===
    const colProduct = margin + 5;
    const colQty = 130;
    const colRate = 160;
    const colAmount = pageWidth - margin - 5;

    doc.setTextColor(60, 60, 60);
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text("PRODUCT", colProduct, tableCurrentY);
    doc.text("QTY", colQty, tableCurrentY, { align: "center" });
    doc.text("RATE", colRate, tableCurrentY, { align: "center" });
    doc.text("AMOUNT", colAmount, tableCurrentY, { align: "right" });

    // Underline
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.line(colProduct, tableCurrentY + 2, colAmount, tableCurrentY + 2);
    tableCurrentY += 6;

    // Store the start of table body for border drawing
    const tableBodyStartY = tableCurrentY;

    // === TABLE BODY ===
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    let lastItemY = tableCurrentY;
    let tableEndY = tableCurrentY; // Track the end of table for border

    for (let i = 0; i < cartProducts.length; i++) {
      const item = cartProducts[i];
      const rowHeight = 6;

      if (tableCurrentY + rowHeight > pageHeight - margin) {
        // Draw border around current table section before page break
        const currentTableHeight = tableCurrentY - tableBodyStartY;
        if (currentPage >= 2) {
          // Draw complete table border for continued pages
          doc.setDrawColor(226, 232, 240);
          doc.setLineWidth(0.5);
          doc.rect(margin, tableBodyStartY - 21, contentWidth, currentTableHeight + 21, 'S');
        } else {
          // Draw border for first page
          doc.setDrawColor(226, 232, 240);
          doc.setLineWidth(0.5);
          doc.rect(margin, tableStartY, contentWidth, currentTableHeight + 21, 'S');
        }

        doc.addPage();
        currentPage++;
        tableCurrentY = 25;
        isTableContinued = true;

        // Re-add header for continued table
        doc.setFillColor(248, 250, 252);
        doc.setDrawColor(226, 232, 240);
        doc.setLineWidth(0.5);
        doc.rect(margin, tableCurrentY, contentWidth, 10, 'FD');

        doc.setFillColor(30, 58, 138);
        doc.rect(margin, tableCurrentY, contentWidth, 10, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text("ORDER SUMMARY (CONTINUED)", margin + 5, tableCurrentY + 6.5);

        tableCurrentY += 15;

        // Re-add column headers
        doc.setTextColor(60, 60, 60);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text("PRODUCT", colProduct, tableCurrentY);
        doc.text("QTY", colQty, tableCurrentY, { align: "center" });
        doc.text("RATE", colRate, tableCurrentY, { align: "center" });
        doc.text("AMOUNT", colAmount, tableCurrentY, { align: "right" });

        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.3);
        doc.line(colProduct, tableCurrentY + 2, colAmount, tableCurrentY + 2);
        tableCurrentY += 6;

        // Reset table body start for new page
        const newTableBodyStartY = tableCurrentY;
      }

      // Alternate row color
      if (i % 2 === 0) {
        doc.setFillColor(252, 252, 252);
        doc.rect(margin + 1, tableCurrentY - 1, contentWidth - 2, rowHeight, 'F');
      }

      // Product name
      const maxNameWidth = 90;
      let itemName = item.name;
      if (doc.getTextWidth(itemName) > maxNameWidth) {
        itemName = item.name.length > 35 ? item.name.substring(0, 35) + '...' : item.name;
      }
      doc.setTextColor(60, 60, 60);
      doc.text(itemName, colProduct, tableCurrentY + 2);

      // Qty
      doc.text(item.quantity.toString(), colQty, tableCurrentY + 2, { align: "center" });

      // Rate
      doc.text(`Rs ${item.price.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, colRate, tableCurrentY + 2, { align: "center" });

      // Amount
      doc.setFont("helvetica", "bold");
      doc.text(`Rs ${item.subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, colAmount, tableCurrentY + 2, { align: "right" });
      doc.setFont("helvetica", "normal");

      lastItemY = tableCurrentY;
      tableCurrentY += rowHeight;
      tableEndY = tableCurrentY; // Update table end position
    }

    // === Add Summary Rows Inside Table ===

    // Add separator line
    tableCurrentY += 2;
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(colProduct, tableCurrentY, colAmount, tableCurrentY);
    tableCurrentY += 4;

    // Subtotal (MRP) row with light gray background
    doc.setFillColor(248, 250, 252);
    doc.rect(margin + 1, tableCurrentY - 1, contentWidth - 2, 6, 'F');

    doc.setTextColor(75, 85, 99);
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text("Subtotal (MRP):", colProduct, tableCurrentY + 2);
    doc.text(`Rs ${netTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, colAmount, tableCurrentY + 2, { align: "right" });
    tableCurrentY += 6;

    // Discount row with light green background
    doc.setFillColor(240, 253, 244);
    doc.rect(margin + 1, tableCurrentY - 1, contentWidth - 2, 6, 'F');

    doc.setTextColor(34, 197, 94);
    doc.setFont("helvetica", "bold");
    doc.text("Discount:", colProduct, tableCurrentY + 2);
    doc.text(`- Rs ${discountTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, colAmount, tableCurrentY + 2, { align: "right" });
    tableCurrentY += 6;

    // Another separator line before total
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(colProduct, tableCurrentY, colAmount, tableCurrentY);
    tableCurrentY += 4;

    // Total amount row with light blue background
    doc.setFillColor(239, 246, 255);
    doc.rect(margin + 1, tableCurrentY - 1, contentWidth - 2, 8, 'F');

    doc.setTextColor(30, 58, 138);
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("TOTAL AMOUNT:", colProduct, tableCurrentY + 2);
    doc.setFontSize(12);
    doc.text(`Rs ${subTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, colAmount, tableCurrentY + 2, { align: "right" });
    tableCurrentY += 8;

    // === Final Border for Table (including summary rows) ===
    if (currentPage >= 2) {
      // For continued pages, draw borders from table header start to table end
      const tableHeaderStartY = isTableContinued ? 25 : tableStartY;
      const finalTableHeight = tableCurrentY - tableHeaderStartY;
      doc.setDrawColor(226, 232, 240);
      doc.setLineWidth(0.5);
      doc.rect(margin, tableHeaderStartY, contentWidth, finalTableHeight, 'S');
    } else {
      // For first page
      const tableFinalHeight = tableCurrentY - tableStartY;
      doc.setDrawColor(226, 232, 240);
      doc.setLineWidth(0.5);
      doc.rect(margin, tableStartY, contentWidth, tableFinalHeight, 'S');
    }

    // === Thank You Banner ===
    tableCurrentY += 10;
    tableCurrentY = checkPageBreak(tableCurrentY, 25);

    // Add left/right borders only on continued pages
    if (currentPage > 1) {
      doc.setDrawColor(245, 158, 11);
      doc.setLineWidth(0.5);
      doc.line(margin, tableCurrentY, margin, tableCurrentY + 20); // Left
      doc.line(pageWidth - margin, tableCurrentY, pageWidth - margin, tableCurrentY + 20); // Right
    }

    // Fill banner
    doc.setFillColor(254, 240, 138);
    doc.rect(margin, tableCurrentY, contentWidth, 20, 'FD');

    doc.setTextColor(146, 64, 14);
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Get Ready to Light Up the Sky!", pageWidth / 2, tableCurrentY + 8, { align: "center" });
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("Your premium fireworks are being prepared with care. Thank you for celebrating with us!", pageWidth / 2, tableCurrentY + 15, { align: "center" });
    tableCurrentY += 30;

    // === Footer - Always at bottom of last page ===
    // Add new page if not enough space for footer
    if (tableCurrentY + 25 > pageHeight - margin) {
      doc.addPage();
      currentPage++;
      tableCurrentY = 25; // Reset Y position for new page
    }

    // Position footer at bottom of the page
    const footerY = pageHeight - 25;
    doc.setFillColor(248, 250, 252);
    doc.rect(0, footerY, pageWidth, 25, 'F');
    doc.setTextColor(100, 100, 100);
    doc.setFontSize(7);
    doc.setFont("helvetica", "normal");
    doc.text("Contact: +91-9751043474 ,+91-9843655396", margin, footerY + 8);
    doc.text("haribalajitraders@gmail.com", pageWidth / 2, footerY + 8, { align: "center" });
    doc.text(`Generated: ${new Date().toLocaleString('en-GB')}`, pageWidth - margin, footerY + 8, { align: "right" });

    if (currentPage > 1) {
      doc.setTextColor(100, 100, 100);
      doc.setFontSize(8);
      doc.text(`Page ${currentPage}`, pageWidth - margin, footerY + 18, { align: "right" });
    }

    // === Save and Upload ===
    doc.save(`${orderId}_Hari_Balaji_Traders_Order.pdf`);
    const pdfBlob = doc.output('blob');
    const blobUrl = URL.createObjectURL(pdfBlob);
    window.open(blobUrl, '_blank');

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("OrderId", orderId);
      formDataToSend.append("Document", pdfBlob, `Order_${orderId}.pdf`);
      formDataToSend.append("CompanyId", 3);

      const uploadRes = await axios.post(
        `${API_BASE_URL}api/Crackers/SendorderedDoc`,
        formDataToSend,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (uploadRes.data.statusCode === 200) {
        const documentUrl = uploadRes.data.data?.documentUrl;
        if (!documentUrl) throw new Error("No document URL returned");

        try {
          const whatsappPayload = {
            to: formData.whatsappNumber || formData.contactNumber,
            pdfUrl: documentUrl,
            text: `HARI BALAJI TRADERS Order #${orderId}`,
            orderNumber: orderId,
            companyName: "HARI BALAJI TRADERS"
          };

          const whatsappResponse = await axios.post(
            `${API_BASE_URL}api/Whatsapp/SendMessage/sendmessage`,
            whatsappPayload,
            { headers: { 'Content-Type': 'application/json' } }
          );

          if (whatsappResponse.data.statusCode === 200) {
            console.log("WhatsApp message sent successfully");
          } else {
            console.warn("Failed to send WhatsApp:", whatsappResponse.data);
          }
        } catch (whatsappError) {
          console.error("Error sending WhatsApp:", whatsappError);
        }

        return uploadRes.data;
      } else {
        throw new Error(uploadRes.data.statusDesc || "Upload failed");
      }
    } catch (err) {
      const errorMsg = err.response?.data?.statusDesc || err.message || "Failed to upload PDF.";
      console.error("Error in generateOrderPDF:", errorMsg, err);
      throw new Error(errorMsg);
    }
  };

  const RemoveConfirmationPopup = () => (
    <div style={styles.popupOverlay}>
      <div style={{
        ...styles.popupContainer,
        maxWidth: isMobile ? '90%' : '400px',
      }}>
        <div style={styles.popupHeader}>
          <h3 style={{
            ...styles.popupTitle,
            fontSize: isMobile ? '1rem' : '1.2rem',
          }}>
            Remove Item?
          </h3>
        </div>
        <div style={styles.popupContent}>
          <p style={{
            color: '#64748b',
            fontSize: isMobile ? '0.85rem' : '0.9rem',
            textAlign: 'center',
            marginBottom: 0,
          }}>
            Are you sure you want to remove "{productToRemove?.name}" from your order?
          </p>
        </div>
        <div style={{
          ...styles.popupFooter,
          justifyContent: 'center',
        }}>
          <button
            onClick={() => {
              // Restore quantity to 1 instead of previous quantity
              setCartProducts(prevProducts =>
                prevProducts.map(product =>
                  product.id === productToRemove?.id
                    ? { ...product, quantity: 1, subtotal: product.price * 1 }
                    : product
                )
              );
              setShowRemoveConfirm(false);
            }}
            style={{
              padding: isMobile ? '0.75rem 1.5rem' : '0.5rem 1rem',
              border: '1px solid #cbd5e1',
              backgroundColor: 'white',
              color: '#1e293b',
              borderRadius: '0.375rem',
              cursor: 'pointer',
              fontWeight: 500,
              fontSize: isMobile ? '0.9rem' : '0.85rem',
              minWidth: isMobile ? '100px' : '80px',
            }}
          >
            Keep Item
          </button>
          <button
            onClick={() => {
              // Actually remove the product
              setCartProducts(prevProducts =>
                prevProducts.filter(product => product.id !== productToRemove?.id)
              );
              setShowRemoveConfirm(false);
            }}
            style={{
              padding: isMobile ? '0.75rem 1.5rem' : '0.5rem 1rem',
              backgroundColor: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: isMobile ? '0.9rem' : '0.85rem',
              minWidth: isMobile ? '100px' : '80px',
            }}
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );

  const CancelConfirmationPopup = () => (
    <div style={styles.popupOverlay}>
      <div style={{
        ...styles.popupContainer,
        maxWidth: isMobile ? '90%' : '400px',
      }}>
        <div style={styles.popupHeader}>
          <h3 style={{
            ...styles.popupTitle,
            fontSize: isMobile ? '1rem' : '1.2rem',
          }}>
            Cancel Order?
          </h3>
        </div>
        <div style={styles.popupContent}>
          <p style={{
            color: '#64748b',
            fontSize: isMobile ? '0.85rem' : '0.9rem',
            textAlign: 'center',
            marginBottom: 0,
          }}>
            Are you sure you want to cancel your order? All entered details and items will be cleared.
          </p>
        </div>
        <div style={{
          ...styles.popupFooter,
          justifyContent: 'center',
        }}>
          <button
            onClick={() => setShowCancelPopup(false)}
            style={{
              padding: isMobile ? '0.75rem 1.5rem' : '0.5rem 1rem',
              border: '1px solid #cbd5e1',
              backgroundColor: 'white',
              color: '#1e293b',
              borderRadius: '0.375rem',
              cursor: 'pointer',
              fontWeight: 500,
              fontSize: isMobile ? '0.9rem' : '0.85rem',
              minWidth: isMobile ? '100px' : '80px',
            }}
          >
            No
          </button>
          <button
            onClick={() => {
              // 1. Clear ALL form data
              setFormData({
                firstName: '',
                lastName: '',
                contactNumber: '',
                whatsappNumber: '',
                sameAsContact: false,
                address: '',
                city: '',
                district: '', // Fixed: use lowercase 'd' to match your form
                state: '',
                pinCode: '',
                email: '',
                createAccount: false,
              });
              // 2. Clear ALL cart data (both states and localStorage)
              setCartItems({});
              localStorage.removeItem('cart');
              setCartProducts([]);
              setQuantities({});
              // 3. Reset the form section states
              setOpenSections({ personal: true, address: false, bank: false });
              // 4. Hide ALL relevant UI components
              setShowTermsPopup(false);
              setShowCancelPopup(false);
              setShowDetailsForm(false);
              setShowOrderCard(false); // ✅ CRITICAL: This was missing!
              // 5. Force a scroll to the top AFTER state updates
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            style={{
              padding: isMobile ? '0.75rem 1.5rem' : '0.5rem 1rem',
              backgroundColor: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: isMobile ? '0.9rem' : '0.85rem',
              minWidth: isMobile ? '100px' : '80px',
            }}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
  const formatINR = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  const [showTermsPopup, setShowTermsPopup] = useState(false);

  const TermsPopup = () => (
    <div style={styles.popupOverlay}>
      <div style={styles.popupContainer}>
        <div style={styles.popupHeader}>
          <h2 style={styles.popupTitle}>
            Terms and Conditions
          </h2>
          <button
            onClick={() => setShowTermsPopup(false)}
            style={styles.popupCloseButton}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#f1f5f9')}
            onMouseOut={(e) => (e.target.style.backgroundColor = 'transparent')}
          >
            ×
          </button>
        </div>
        <div style={styles.popupContent}>
          <p style={{ marginTop: 0, marginBottom: '1rem' }}>
            Welcome to Hari Balaji Traders. These Terms and Conditions govern your use of our website and services. Please read them carefully before placing an order.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            <strong>1. Acceptance of Terms</strong><br />
            By accessing or using our services, you agree to be bound by these terms. If you do not agree, please do not use our services.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            <strong>2. Orders and Payments</strong><br />
            All orders are subject to availability and confirmation of payment. We reserve the right to cancel any order at any time.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            <strong>3. Shipping and Delivery</strong><br />
            We aim to dispatch your order within 1–2 business days. Delivery times may vary based on your location.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            <strong>4. Returns and Refunds</strong><br />
            Due to the nature of our products, returns are only accepted in case of damaged or defective items.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            <strong>5. Safety and Legal Compliance</strong><br />
            Fireworks are hazardous goods. You confirm that you are of legal age and responsible for complying with local laws regarding purchase and use.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            <strong>6. Limitation of Liability</strong><br />
            In no event shall Hari Balaji Traders Traders be liable for any indirect, incidental, or consequential damages arising out of the use of our products.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            <strong>7. Policy Updates</strong><br />
            We may update these terms from time to time. Continued use of the service constitutes acceptance of the updated terms.
          </p>
          <p style={{ marginBottom: 0 }}>
            <strong>8. Governing Law</strong><br />
            These Terms are governed by the laws of India. Any disputes shall be resolved in the courts of [City], India.
          </p>
        </div>
      </div>
    </div>
  );

  // Processing Overlay Component
  const ProcessingOverlay = () => (
    <div style={styles.processingOverlay}>
      <div style={styles.processingContent}>
        <div className="spinner" style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #2F3E9E',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}></div>
        <div style={styles.processingText}>Processing your order...</div>
      </div>
    </div>
  );
  const ImagePreviewPopup = () => (
    previewImage && (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: '2rem',
      }}>
        <button
          onClick={() => setPreviewImage(null)}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '36px',
            fontWeight: 'bold',
            cursor: 'pointer',
            zIndex: 2001,
            width: '50px',
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            backgroundColor: 'rgba(255,255,255,0.1)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
            e.target.style.transform = 'scale(1)';
          }}
        >
          ×
        </button>
        <img
          src={previewImage}
          alt="Preview"
          style={{
            maxWidth: '90%',
            maxHeight: '90%',
            objectFit: 'contain',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
            border: '2px solid rgba(255,255,255,0.1)',
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    )
  );
  return (
    <>
      <style>
        {`
          .product-card:hover .hold-badge {
            opacity: 1 !important;
          }
        `}
      </style>
      <Header />

      {!showOrderCard && (
        <div style={{...styles.container, paddingTop: '0', paddingLeft: '0', paddingRight: '0'}}>
          
          {/* Minimum Order Amount Banner - Full Width */}
          <div style={{
            width: '100%',
            backgroundColor: '#dc2626',
            color: 'white',
            padding: '0.8rem 1.5rem',
            textAlign: 'center',
            fontSize: '1.1rem',
            fontWeight: 'bold',
            boxShadow: '0 4px 12px rgba(220, 38, 38, 0.3)',
            marginBottom: '1rem',
            marginTop: '0',
            marginLeft: '0',
            marginRight: '0'
          }}>
            Minimum Order Amount Rs: {minOrderAmount.toLocaleString('en-IN')}
          </div>

          {/* Content with padding */}
          <div style={{ padding: '0 1rem' }}>
          {/* Search Bar */}
          <div style={{
            maxWidth: '600px',
            margin: '0 auto 1rem',
            padding: '0'
          }}>
            <div style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center'
            }}>
              <FiSearch style={{
                position: 'absolute',
                left: '15px',
                color: '#5e045bff',
                fontSize: '1.2rem'
              }} />
              <input
                type="text"
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.8rem 1rem 0.8rem 3rem',
                  border: '2px solid #5e045bff',
                  borderRadius: '25px',
                  fontSize: '1rem',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 8px rgba(94, 4, 91, 0.1)'
                }}
                onFocus={(e) => {
                  e.target.style.boxShadow = '0 4px 12px rgba(94, 4, 91, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.boxShadow = '0 2px 8px rgba(94, 4, 91, 0.1)';
                }}
              />
            </div>
          </div>
          
          {loading && <p style={styles.loading}>Loading products...</p>}
          {error && <p style={styles.error}>{error}</p>}
          {!loading && !error && Object.keys(categories).length === 0 && (
            <p style={styles.noData}>No products found.</p>
          )}

          {/* Render each category */}
          {Object.keys(categories)
            .map((categoryName) => {
              // Filter products based on search term
              const filteredProducts = categories[categoryName].filter(product =>
                product.prodName.toLowerCase().includes(searchTerm.toLowerCase())
              );
              
              // Only return category if it has matching products
              if (filteredProducts.length === 0) return null;
              
              return (
                <div key={categoryName} style={styles.categorySection}>
                  <h2 style={styles.categoryTitle}>{categoryName.toUpperCase()}</h2>
                  <div style={styles.productGrid}>
                {filteredProducts.map((product) => {
                  const marketPrice = product.prodPrice || 0;
                  const discountPrice = product.discountPrice || 0;
                  const discountPercent = getDiscountPercent(marketPrice, discountPrice);
                  const quantity = quantities[product.id] || '';
                  const isOnHold = product.productStatus === 'Hold';
                  
                  // Handle card click to increase quantity
                  const handleCardClick = (e) => {
                    // Don't allow adding if product is on hold
                    if (isOnHold) {
                      return;
                    }
                    // Don't trigger if clicking on input field or image
                    if (e.target.tagName === 'INPUT' || e.target.tagName === 'IMG') {
                      return;
                    }
                    const currentQty = quantities[product.id] || 0;
                    handleQuantityChange(product.id, currentQty + 1, product);
                  };
                  
                  return (
                    <div 
                      key={product.id}
                      className="product-card"
                      style={{
                        ...styles.productCard, 
                        cursor: isOnHold ? 'not-allowed' : 'pointer',
                        position: 'relative',
                        backgroundColor: styles.productCard.backgroundColor
                      }} 
                      onClick={handleCardClick}
                      onMouseEnter={(e) => {
                        if (isOnHold) {
                          e.currentTarget.style.backgroundColor = '#ffcccc';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = styles.productCard.backgroundColor;
                      }}
                      title={isOnHold ? 'This product is currently on hold' : ''}
                    >
                      {/* Discount Badge - Top Right Corner */}
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        padding: '0.25rem 0.4rem',
                        borderRadius: '4px',
                        fontSize: '0.7rem',
                        fontWeight: 'bold',
                        zIndex: 2,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                      }}>
                        ({discountPercent}% OFF)
                      </div>

                      {/* ON HOLD Badge - only show on hover, top left */}
                      {isOnHold && (
                        <div 
                          className="hold-badge"
                          style={{
                            position: 'absolute',
                            top: '8px',
                            left: '8px',
                            backgroundColor: 'rgba(220, 53, 69, 0.95)',
                            color: '#ffffff',
                            padding: '0.3rem 0.6rem',
                            borderRadius: '4px',
                            fontSize: '0.7rem',
                            fontWeight: 'bold',
                            zIndex: 2,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            opacity: 0,
                            transition: 'opacity 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.opacity = '1';
                          }}
                        >
                          HOLD
                        </div>
                      )}
                      
                      {/* Top Row: Market Price (Left) and Discount Price (Right) */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: '0.3rem',
                        minHeight: '35px'
                      }}>
                        {/* Left: Market Price label */}
                        <div style={{ textAlign: 'left', fontSize: '0.65rem', color: '#666' }}>
                          Rs. {formatPrice(marketPrice)}
                        </div>
                        
                        {/* Right: Discount Price label */}
                        <div style={{ textAlign: 'right', fontSize: '0.65rem', color: '#666' }}>
                          Rs. {formatPrice(discountPrice)}
                        </div>
                      </div>

                      {/* Image */}
                      {product.prodImage?.trim() ? (
                        <div style={styles.productImageContainer}>
                          <img
                            src={product.prodImage.trim()}
                            alt={product.prodName}
                            style={styles.productImage}
                            onClick={(e) => {
                              e.stopPropagation();
                              setPreviewImage(product.prodImage.trim());
                            }}
                          />
                        </div>
                      ) : (
                        <div style={{...styles.productImageContainer, backgroundColor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                          <span style={{color: '#999', fontSize: '0.9rem', fontWeight: '500'}}>No Image</span>
                        </div>
                      )}

                      {/* Product Name - Below Image */}
                      <div style={{
                        textAlign: 'center',
                        marginTop: '0.4rem',
                        marginBottom: '0.4rem'
                      }}>
                        <h3 style={{
                          fontSize: '0.8rem',
                          fontWeight: '600',
                          color: '#2c3e50',
                          margin: 0,
                          lineHeight: '1.2'
                        }}>
                          {product.prodName}
                        </h3>
                      </div>

                      {/* Price Row - Below Product Name */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '0.5rem',
                        padding: '0 0.2rem'
                      }}>
                        {/* Left: Market Price with red strikethrough */}
                        <div style={{ 
                          fontSize: '0.8rem', 
                          color: '#dc2626', 
                          fontWeight: 'bold',
                          textDecoration: 'line-through'
                        }}>
                          RS. {formatPrice(marketPrice)}
                        </div>
                        
                        {/* Right: Discount Price in green */}
                        <div style={{ 
                          fontSize: '0.85rem', 
                          color: '#4CAF50', 
                          fontWeight: 'bold'
                        }}>
                          RS. {formatPrice(discountPrice)}
                        </div>
                      </div>

                      {/* Bottom Row: Quantity Controls with +/- buttons */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '0.4rem',
                        width: '100%',
                        gap: '0.3rem'
                      }}>
                        {/* Minus Button - Left Side */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!isOnHold) {
                              const currentQty = quantities[product.id] || 0;
                              if (currentQty > 1) {
                                handleQuantityChange(product.id, currentQty - 1, product);
                              }
                            }
                          }}
                          disabled={isOnHold || !quantities[product.id] || quantities[product.id] <= 1}
                          style={{
                            width: '28px',
                            height: '28px',
                            border: 'none',
                            backgroundColor: '#5e045bff',
                            color: 'white',
                            borderRadius: '4px',
                            cursor: isOnHold ? 'not-allowed' : 'pointer',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: (isOnHold || !quantities[product.id] || quantities[product.id] <= 1) ? 0.5 : 1,
                            transition: 'all 0.2s ease',
                            flexShrink: 0
                          }}
                        >
                          -
                        </button>

                        {/* Quantity Input - Center */}
                        <input
                          type="number"
                          value={quantities[product.id] ?? ''}
                          min="1"
                          placeholder="0"
                          onChange={(e) => !isOnHold && handleQuantityChange(product.id, e.target.value, product)}
                          onClick={(e) => e.stopPropagation()}
                          disabled={isOnHold}
                          style={{
                            width: '50px',
                            height: '28px',
                            border: '1px solid #5e045bff',
                            borderRadius: '4px',
                            textAlign: 'center',
                            fontSize: '0.85rem',
                            fontWeight: '600',
                            backgroundColor: isOnHold ? '#f5f5f5' : 'white',
                            cursor: isOnHold ? 'not-allowed' : 'text',
                            color: isOnHold ? '#999' : '#333',
                            padding: '0',
                            outline: 'none',
                            transition: 'all 0.2s ease'
                          }}
                          onFocus={(e) => {
                            if (!isOnHold) {
                              e.target.style.borderColor = '#f5ae42ff';
                              e.target.style.boxShadow = '0 0 0 2px rgba(245, 174, 66, 0.1)';
                            }
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = '#5e045bff';
                            e.target.style.boxShadow = 'none';
                          }}
                        />

                        {/* Plus Button - Right Side */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!isOnHold) {
                              const currentQty = quantities[product.id] || 0;
                              handleQuantityChange(product.id, currentQty + 1, product);
                            }
                          }}
                          disabled={isOnHold}
                          style={{
                            width: '28px',
                            height: '28px',
                            border: 'none',
                            backgroundColor: '#5e045bff',
                            color: 'white',
                            borderRadius: '4px',
                            cursor: isOnHold ? 'not-allowed' : 'pointer',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: isOnHold ? 0.5 : 1,
                            transition: 'all 0.2s ease',
                            flexShrink: 0
                          }}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }).filter(Boolean)}

          {/* Cart Summary */}
          {productCount > 0 && !showOrderCard && (
            <div style={styles.cartSummaryContainer}>
              <div style={styles.cartSummaryContent}>
                <div style={styles.cartIconContainer}>
                  <FiShoppingCart style={styles.cartIcon} />
                  <span style={styles.cartBadge}>{productCount}</span>
                </div>
                <button onClick={handleViewCart} style={viewCartButtonStyle}>
                  View Cart ({productCount} items)
                </button>
              </div>
            </div>
          )}
          </div>
        </div>
      )}

      {showOrderCard && (
        <div style={styles.container}>
          <div style={styles.wrapper}>
            <div style={styles.orderCard} id="orderCard">
              {/* Left Card - Order Items */}
              <div style={{ ...styles.card, flex: isMobile ? 1 : 3 }}>
                <div style={styles.cardHeader}>
                  <h2 style={styles.cardTitle}>Your Order</h2>
                </div>
                <div style={styles.cardBody}>
                  <ul style={styles.productList}>
                    {cartProducts.map((product) => (
                      <li key={product.id} style={{ ...styles.productItem, position: 'relative' }}>
                        {/* Remove button */}
                        <button
                          style={{
                            position: 'absolute',
                            right: '1px',
                            top: '-4px',
                            cursor: 'pointer',
                            color: '#b91c1c',
                            zIndex: 1,
                            background: 'none',
                            border: 'none',
                            padding: '2px',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '18px',
                            height: '18px',
                            fontWeight: 'bold'
                          }}
                          onClick={() => {
                            setCartProducts(prevProducts =>
                              prevProducts.filter(p => p.id !== product.id)
                            );
                            setCartItems(prev => {
                              const newCart = { ...prev };
                              delete newCart[product.id];
                              return newCart;
                            });
                            setQuantities(prev => {
                              const newQuantities = { ...prev };
                              delete newQuantities[product.id];
                              return newQuantities;
                            });
                          }}
                        >
                          <FiX />
                        </button>

                        {/* Product Info - Image and Details */}
                        <div style={styles.productInfo}>
                          <img
                            src={product.image || "https://via.placeholder.com/60"}
                            alt={product.name}
                            style={{
                              width: '80px',
                              height: '80px',
                              objectFit: 'contain',
                              borderRadius: '4px',
                              backgroundColor: '#f5f5f5',
                            }}
                          />
                          <div style={styles.productDetails}>
                            <p style={styles.productNameCart}>
                              {product.name}
                            </p>

                            {/* Price info for both mobile and desktop */}
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              flexWrap: 'wrap'
                            }}>
                              <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}>
                                <span style={{
                                  textDecoration: 'line-through',
                                  color: '#64748b',
                                  fontSize: isMobile ? '0.65rem' : '0.75rem'
                                }}>
                                  ₹{product.originalPrice.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </span>
                                <span style={{
                                  fontWeight: 'bold',
                                  fontSize: isMobile ? '0.7rem' : '0.75rem'
                                }}>
                                  ₹{product.price.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </span>
                              </div>
                              <div style={{
                                color: '#10B981',
                                fontSize: isMobile ? '0.65rem' : '0.75rem',
                                fontWeight: 'bold',
                                padding: '0.15rem 0.3rem',
                                borderRadius: '0.25rem',
                                backgroundColor: '#ecfdf5',
                                border: '1px solid #10B981',
                                whiteSpace: 'nowrap',
                              }}>
                                Save {product.discountPercent}%
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Quantity Input and Subtotal */}
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          flexShrink: 0,
                          minWidth: isMobile ? '100px' : '120px',
                          justifyContent: 'flex-end'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.3rem'
                          }}>
                            {isMobile && (
                              <span style={{
                                fontSize: '0.7rem',
                                color: '#64748b'
                              }}>Qty:</span>
                            )}
                            <input
                              type="number"
                              value={product.quantity}
                              onChange={(e) => updateQuantity(product.id, e.target.value)}
                              style={{
                                ...styles.quantityInputStyle,
                                width: isMobile ? '45px' : '50px',
                              }}
                            />
                          </div>

                          {/* Subtotal */}
                          <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            minWidth: isMobile ? '60px' : '70px'
                          }}>
                            <div style={{
                              textDecoration: 'line-through',
                              color: '#64748b',
                              fontSize: isMobile ? '0.65rem' : '0.7rem'
                            }}>
                              ₹{(product.originalPrice * product.quantity).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </div>
                            <div style={{
                              fontSize: isMobile ? '0.8rem' : '0.85rem',
                              fontWeight: 'bold'
                            }}>
                              ₹{product.subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Right Card - Price Details */}
              <div style={{ ...styles.card, flex: isMobile ? 1 : 2 }}>
                <div style={styles.cardHeader}>
                  <h2 style={styles.cardTitle}>Price Details</h2>
                </div>
                <div style={{ ...styles.totalsSection, display: 'flex', flexDirection: 'column', height: '80%', justifyContent: 'space-between' }}>
                  <div style={styles.totalRow}>
                    <span style={styles.totalLabel}>Price ({cartProducts.length} item{cartProducts.length !== 1 ? 's' : ''})</span>
                    <span style={styles.totalValue}>₹{netTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                  <div style={styles.totalRow}>
                    <span style={styles.totalLabel}>Discount</span>
                    <span style={{ ...styles.totalValue, color: '#10B981' }}>
                      -₹{discountTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  </div>
                  <div style={{ ...styles.totalRow, ...styles.grandTotal }}>
                    <span>Total Amount</span>
                    <span>₹{subTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>

                  {/* Add the minimum amount warning */}
                  {amountBelowMinimum && (
                    <div style={{
                      color: '#dc2626',
                      fontSize: isMobile ? '0.8rem' : '0.85rem',
                      textAlign: 'center',
                      margin: '0.5rem 0',
                      padding: '0.5rem',
                      backgroundColor: '#fee2e2',
                      borderRadius: '0.25rem'
                    }}>
                      Minimum order value: ₹{minOrderAmount.toLocaleString('en-IN')}
                    </div>
                  )}

                  <div style={{
                    padding: isMobile ? '0.75rem' : '0.1rem',
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '0.5rem',
                    gap: isMobile ? '0.5rem' : '0',
                    marginTop: 'auto',
                  }}>
                    <button
                      style={styles.proceedButton}
                      onClick={() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
                        setShowOrderCard(false); // Hide order card (go back)
                      }}
                    >
                      Back
                    </button>
                    <button
                      style={{
                        ...styles.proceedButton,
                        opacity: amountBelowMinimum ? 0.6 : 1,
                        cursor: amountBelowMinimum ? 'not-allowed' : 'pointer'
                      }}
                      onClick={handleProceedClick}
                      disabled={amountBelowMinimum}
                    >
                      {showDetailsForm ? 'NEXT' : 'NEXT'}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Order Details Form */}
            {showDetailsForm && (
              <div style={styles.card} id="orderDetailsForm" ref={formRef}>
                <div style={styles.formContainer}>
                  <div style={styles.cardHeader}>
                    <h2 style={styles.cardTitle}>Fill Your Details</h2>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div style={styles.formBody}>
                      <div style={styles.formDetailsColumns}>
                        {/* Left Column - Personal Information */}
                        <div style={styles.formColumn}>
                          <div style={styles.sectionTitle}>
                            <span>📋 Personal Information</span>
                          </div>
                          <div style={{ ...styles.sectionContent, ...styles.sectionContentOpen }}>
                            {/* Name Fields */}
                            <div style={styles.formRow}>
                              <div style={styles.formGroup}>
                                <label style={styles.formLabel}>First Name<span style={styles.requiredField}>*</span></label>
                                <input
                                  type="text"
                                  name="firstName"
                                  value={formData.firstName}
                                  onChange={handleChange}
                                  style={styles.formInput}
                                  placeholder='Enter your first name'
                                  required
                                />
                              </div>
                              <div style={styles.formGroup}>
                                <label style={styles.formLabel}>Last Name</label>
                                <input
                                  type="text"
                                  name="lastName"
                                  value={formData.lastName}
                                  onChange={handleChange}
                                  style={styles.formInput}
                                  placeholder='Enter your last name'
                                />
                              </div>
                            </div>

                            {/* Contact and WhatsApp Row for Desktop / Separate for Mobile */}
                            {isMobile ? (
                              // Mobile: Contact Number, then Checkbox, then WhatsApp, then Email
                              <>
                                <div style={styles.formRow}>
                                  <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>
                                      Contact Number<span style={styles.requiredField}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      name="contactNumber"
                                      value={formData.contactNumber}
                                      onChange={handleChange}
                                      style={styles.formInput}
                                      placeholder="Enter 10-digit mobile number"
                                      maxLength="10"
                                      required
                                    />
                                  </div>
                                </div>
                                <div style={styles.formRow}>
                                  <div style={styles.formGroup}>
                                    <div style={styles.checkboxContainer}>
                                      <input
                                        type="checkbox"
                                        name="sameAsContact"
                                        checked={formData.sameAsContact}
                                        onChange={handleChange}
                                        style={styles.formCheckbox}
                                      />
                                      <label style={{ fontSize: isMobile ? '0.85rem' : '0.8rem', color: '#64748b' }}>
                                        Same as Contact Number
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div style={styles.formRow}>
                                  <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>
                                      WhatsApp Number<span style={styles.requiredField}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      name="whatsappNumber"
                                      value={formData.whatsappNumber}
                                      onChange={handleChange}
                                      style={{
                                        ...styles.formInput,
                                        backgroundColor: formData.sameAsContact ? '#f0f0f0' : 'white',
                                        cursor: formData.sameAsContact ? 'not-allowed' : 'text'
                                      }}
                                      placeholder={formData.sameAsContact ? "Same as Contact Number" : "Enter 10-digit WhatsApp number"}
                                      maxLength="10"
                                      required
                                      disabled={formData.sameAsContact}
                                    />
                                  </div>
                                </div>
                                <div style={styles.formRow}>
                                  <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>Email Address</label>
                                    <input
                                      type="email"
                                      name="email"
                                      value={formData.email}
                                      onChange={handleChange}
                                      style={styles.formInput}
                                      placeholder='Enter your email address'
                                    />
                                  </div>
                                </div>
                              </>
                            ) : (
                              // Desktop: Contact and WhatsApp in same row, Email and Checkbox in second row
                              <>
                                <div style={styles.formRow}>
                                  <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>
                                      Contact Number<span style={styles.requiredField}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      name="contactNumber"
                                      value={formData.contactNumber}
                                      onChange={handleChange}
                                      style={styles.formInput}
                                      placeholder="Enter 10-digit mobile number"
                                      maxLength="10"
                                      required
                                    />
                                  </div>
                                  <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>
                                      WhatsApp Number<span style={styles.requiredField}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      name="whatsappNumber"
                                      value={formData.whatsappNumber}
                                      onChange={handleChange}
                                      style={{
                                        ...styles.formInput,
                                        backgroundColor: formData.sameAsContact ? '#f0f0f0' : 'white',
                                        cursor: formData.sameAsContact ? 'not-allowed' : 'text'
                                      }}
                                      placeholder={formData.sameAsContact ? "Same as Contact Number" : "Enter 10-digit WhatsApp number"}
                                      maxLength="10"
                                      required
                                      disabled={formData.sameAsContact}
                                    />
                                    {/* Checkbox directly below WhatsApp field in desktop */}
                                    <div style={{ ...styles.checkboxContainer, marginTop: '0.25rem' }}>
                                      <input
                                        type="checkbox"
                                        name="sameAsContact"
                                        checked={formData.sameAsContact}
                                        onChange={handleChange}
                                        style={styles.formCheckbox}
                                      />
                                      <label style={{ fontSize: '0.8rem', color: '#64748b' }}>
                                        Same as Contact Number
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div style={{ ...styles.formRow, marginTop: '0.5rem' }}>
                                  <div style={styles.formGroup}>
                                    <label style={styles.formLabel}>Email Address</label>
                                    <input
                                      type="email"
                                      name="email"
                                      value={formData.email}
                                      onChange={handleChange}
                                      style={styles.formInput}
                                      placeholder='Enter your email address'
                                    />
                                  </div>
                                  {/* Empty div to maintain two-column layout */}
                                  <div style={styles.formGroup}></div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        {/* Right Column - Address Information */}
                        <div style={styles.formColumn}>
                          <div style={styles.sectionTitle}>
                            <span>🏠 Address Information</span>
                          </div>
                          <div style={{ ...styles.sectionContent, ...styles.sectionContentOpen }}>
                            <div style={styles.formRow}>
                              <div style={styles.formGroup}>
                                <label style={styles.formLabel}>House/Flat No., Building Name, Area<span style={styles.requiredField}>*</span></label>
                                <input
                                  name="address"
                                  value={formData.address}
                                  onChange={handleChange}
                                  style={styles.formInput}
                                  placeholder="Enter your (House/Flat No., Building Name, Area)"
                                  required
                                />
                              </div>
                              <div style={styles.formGroup}>
                                <label style={styles.formLabel}>City<span style={styles.requiredField}>*</span></label>
                                <input
                                  type="text"
                                  name="city"
                                  value={formData.city}
                                  onChange={handleChange}
                                  style={styles.formInput}
                                  placeholder="City"
                                  required
                                />
                              </div>
                            </div>
                            <div style={styles.formRow}>
                              <div style={styles.formGroup}>
                                <label style={styles.formLabel}>District<span style={styles.requiredField}>*</span></label>
                                <input
                                  type="text"
                                  name="district"
                                  value={formData.district}
                                  onChange={handleChange}
                                  style={styles.formInput}
                                  placeholder="Enter district"
                                  required
                                />
                              </div>
                              <div style={styles.formGroup}>
                                <label style={styles.formLabel}>State<span style={styles.requiredField}>*</span></label>
                                <input
                                  type="text"
                                  name="state"
                                  value={formData.state}
                                  onChange={handleChange}
                                  style={styles.formInput}
                                  placeholder="State"
                                  required
                                />
                              </div>
                            </div>
                            <div style={styles.formRow}>
                              <div style={styles.formGroup}>
                                <label style={styles.formLabel}>PIN Code<span style={styles.requiredField}>*</span></label>
                                <input
                                  type="text"
                                  name="pinCode"
                                  value={formData.pinCode}
                                  onChange={handleChange}
                                  style={styles.formInput}
                                  placeholder="PIN Code"
                                  maxLength="10"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Submit Section */}
                    <div style={styles.submitSection}>
                      <div style={styles.termsSection}>
                        <input
                          type="checkbox"
                          id="agreeToTerms"
                          name="agreeToTerms"
                          required
                          style={{
                            ...styles.formCheckbox,
                            accentColor: '#1a237e'
                          }}
                        />
                        <label htmlFor="agreeToTerms" style={{ fontSize: isMobile ? '0.9rem' : '0.85rem', color: '#64748b' }}>
                          I have read and agree to the{' '}
                          <span
                            style={{
                              color: '#1a237e',
                              textDecoration: 'underline',
                              cursor: 'pointer'
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              setShowTermsPopup(true);
                            }}
                          >
                            Terms and Conditions
                          </span>
                          <span style={styles.requiredField}> *</span>
                        </label>
                      </div>
                      <div style={styles.actionButtons}>
                        <button
                          type="button"
                          style={styles.confirmButton}
                          onClick={handleConfirmOrder}
                          disabled={isProcessing}
                        >
                          {isProcessing ? 'PROCESSING...' : 'CONFIRM ORDER'}
                        </button>
                        <button
                          type="button"
                          style={styles.cancelButton}
                          onClick={() => setShowCancelPopup(true)}
                          disabled={isProcessing} // Disable during processing
                        >
                          CANCEL
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showRemoveConfirm && <RemoveConfirmationPopup />}
      {showCancelPopup && <CancelConfirmationPopup />}
      {showTermsPopup && <TermsPopup />}
      {/* Image Preview Popup */}
      {previewImage && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2000,
        }}>
          <button
            onClick={() => setPreviewImage(null)}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '28px',
              fontWeight: 'bold',
              cursor: 'pointer',
              zIndex: 2001,
            }}
          >
            &times;
          </button>
          <img
            src={previewImage}
            alt="Preview"
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              objectFit: 'contain',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
            }}
          />
        </div>
      )}
      <Footer />
    </>

  );
};

const viewCartButtonStyle = {
  padding: '0.7rem 1.5rem',
  backgroundColor: '#f09103ff',
  color: 'white',
  textDecoration: 'none',
  borderRadius: '5px',
  fontWeight: 'bold',
  transition: 'all 0.3s ease',
  border: 'none',
  cursor: 'pointer',
  ':hover': {
    backgroundColor: '#e09d2f',
    transform: 'translateY(-2px)'
  }
};

const pageTitleContainerStyle = {
  backgroundImage: `url(${pro_bg})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  padding: '1.4rem',
  borderRadius: '8px',
  marginBottom: '2rem',
  marginTop: "-2.5rem"
};

const pageTitleStyle = {
  fontSize: '2rem',
  color: '#fff',
  textAlign: 'center',
  marginBottom: '2rem',
};
const slidingTextContainerStyle = {
  background: 'linear-gradient(90deg, #F4D03F, #F39C12)',
  padding: '0.4rem 0',
  overflow: 'hidden',
  position: 'fixed',
  zIndex: '1000',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  width: '100%',
  margin: '0',
  boxSizing: 'border-box',
};
const slidingTextContainerStylefooter = {
  background: 'linear-gradient(90deg, #F4D03F, #F39C12)',
  padding: '0.4rem 0',
  overflow: 'hidden',
  position: 'relative',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  width: '100%',
  margin: '0',
  boxSizing: 'border-box',
};
export default ProductCatalog;